import URL from '../helpers/URL';

;$(function() {

	let hash = URL.hash;
	if (hash != '')
		window.history.pushState("", "", URL.full.substr(0, URL.full.indexOf(URL.hash)));

	if (hash != '#cars') return;

	let block = $('[data-scroll]');
	if (! block) return;

	let header = $('.header__top');

	$('html,body').animate({
		scrollTop: block.offset().top - header.height() - 10
	}, 600);

});